/**
 * Converts string to the binary data
 * @function
 * @param [stringData] {string}
 * @returns {Uint8Array}
 * @example toBinary('some text')
 */
export const toBinary = stringData => {
    const codeUnits = new Uint16Array(stringData.length);

    for (let i = 0; i < codeUnits.length; i++) {
        codeUnits[i] = stringData.charCodeAt(i);
    }

    return String.fromCharCode(...new Uint8Array(codeUnits.buffer));
};

/**
 * Converts binary to the string
 * @function
 * @param [binaryData] {Uint8Array}
 * @returns {string}
 * @example fromBinary(Uint8Array)
 */
export const fromBinary = binaryData => {
    const bytes = new Uint8Array(binaryData.length);

    for (let i = 0; i < bytes.length; i++) {
        bytes[i] = binaryData.charCodeAt(i);
    }

    return String.fromCharCode(...new Uint16Array(bytes.buffer));
};

/**
 * @function
 * @param [object] {Object}
 * @returns {string}
 */
export const encData = object => {
    if (!object) {
        return object;
    }

    const data = JSON.stringify(object);

    try {
        return window.btoa(data);
    } catch {
        // btoa takes only binary string as param (1 character = 1 byte):
        // data should be converted to binary if some characters occupy more than 1 byte
        return window.btoa(toBinary(data));
    }
};
